import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetTeams(isAuthenticated = true) {
  const fetchData = async () => {
    const response = await httpClient.get('team/team', {
      withCredentials: true,
      withXSRFToken: true,
    })
    return response.data.data
  }

  return useQuery({
    queryKey: ['teams'],
    queryFn: fetchData,
    enabled: isAuthenticated,
  })
}
